import { all, fork } from 'redux-saga/effects';

import schedulePatientsSagas from './patients/sagas';

export default function* messagingSagas() {
  yield all([fork(schedulePatientsSagas)]);
}
